<section id="main" class="bg-light">
     <div id="accessDeniedContainer" class="container">
          <div class="row">
               <div class="col-12">
                    <h1 [innerHtml]="'AccessDenied' | translator: 'base'">
                         Access Denied
                    </h1>
                    <div>
                         <p [innerHtml]="'NoPermission' | translator: 'base'">
                              You do not have permission to access the requested page. If you feel you were sent to this
                              page in error, please contact your company's account administrator. If you would like
                              additional information regarding your access please contact customer support
                              at
                              <a href="mailto:PSPHelp@tylertech.com" title="PSPHelp@tylertech.com"
                                   name="PSPHelp@tylertech.com">PSPHelp&#64;tylertech.com</a> or at <a href="tel:1-877-642-9499"
                                   title="1-877-642-9499" name="1-877-642-9499\">1-877-642-9499</a>.
                         </p>
                    </div>
               </div>
          </div>
     </div>
</section>